export default __webpack_public_path__ + "static/media/stewardess.411c837f.png";